(() => {
  let cartCount = 0;

  function animate(el, frames, options) {
    try {
      el.animate(frames, options);
    } catch {
      // Animation is decorative; the UI still works without it.
    }
  }

  function setupStyleHover() {
    document.querySelectorAll("[style-hover]").forEach((el) => {
      const base = el.getAttribute("style") || "";
      const hover = el.getAttribute("style-hover") || "";
      el.addEventListener("mouseenter", () => {
        el.setAttribute("style", `${base}; ${hover}`);
      });
      el.addEventListener("mouseleave", () => {
        el.setAttribute("style", base);
      });
    });
  }

  function setupCart() {
    const count = document.querySelector("#cart-count");
    const bag = document.querySelector("#bag-pill");
    const drawer = document.querySelector("[data-cart-drawer]");
    const itemsEl = document.querySelector("[data-cart-items]");
    const emptyEl = document.querySelector("[data-cart-empty]");
    const footerEl = document.querySelector("[data-cart-footer]");
    const subtotalEl = document.querySelector("[data-cart-subtotal]");
    const closeEls = document.querySelectorAll("[data-cart-close]");
    const cartItems = new Map();

    const money = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });

    const updateCartCount = () => {
      cartCount = [...cartItems.values()].reduce((sum, item) => sum + item.qty, 0);
      if (count) count.textContent = String(cartCount);
    };

    const openCart = () => {
      if (!drawer) return;
      document.body.classList.add("cart-drawer-open");
      drawer.setAttribute("aria-hidden", "false");
      if (bag) bag.setAttribute("aria-expanded", "true");
      requestAnimationFrame(() => drawer.focus({ preventScroll: true }));
    };

    const closeCart = () => {
      if (!drawer) return;
      document.body.classList.remove("cart-drawer-open");
      drawer.setAttribute("aria-hidden", "true");
      if (bag) bag.setAttribute("aria-expanded", "false");
    };

    const renderCart = () => {
      updateCartCount();
      if (!itemsEl || !emptyEl || !footerEl || !subtotalEl) return;

      itemsEl.innerHTML = "";
      const items = [...cartItems.values()];
      emptyEl.hidden = items.length > 0;
      footerEl.hidden = items.length === 0;
      const subtotal = items.reduce((sum, item) => sum + item.qty * item.price, 0);
      subtotalEl.textContent = money.format(subtotal);

      items.forEach((item) => {
        const row = document.createElement("article");
        row.className = "cart-item";
        row.style.setProperty("--cart-item-accent", item.accent);
        row.innerHTML = `
          <div class="cart-item__thumb" style="background-image: url('${item.image}');" aria-hidden="true"></div>
          <div class="cart-item__meta">
            <div class="cart-item__top">
              <div>
                <div class="cart-item__name">${item.name}</div>
                <div class="cart-item__variant">${item.variant}</div>
              </div>
              <div class="cart-item__price">${money.format(item.price)}</div>
            </div>
            <div class="cart-item__controls">
              <div class="cart-item__qty" aria-label="${item.name} quantity">
                <button type="button" data-cart-dec="${item.id}" aria-label="Decrease ${item.name} quantity">−</button>
                <span>${item.qty}</span>
                <button type="button" data-cart-inc="${item.id}" aria-label="Increase ${item.name} quantity">+</button>
              </div>
              <button class="cart-item__remove" type="button" data-cart-remove="${item.id}">Remove</button>
            </div>
          </div>
        `;
        itemsEl.append(row);
      });
    };

    document.querySelectorAll("[data-add-to-bag]").forEach((button) => {
      button.addEventListener("click", () => {
        const id = button.dataset.productId || "mango";
        const item = cartItems.get(id) || {
          id,
          name: button.dataset.productName || "Mango Gummies",
          variant: button.dataset.productVariant || "2 Pack",
          price: Number(button.dataset.productPrice || "9.99"),
          image: button.dataset.productImage || "./assets/Frame 6.png",
          accent: button.dataset.productAccent || "#F6BE3B",
          qty: 0,
        };
        item.qty += 1;
        cartItems.set(id, item);

        animate(button, [
          { transform: "scale(1)" },
          { transform: "scale(0.92) rotate(-2deg)" },
          { transform: "scale(1)" },
        ], { duration: 240, easing: "ease-out" });

        if (bag) {
          animate(bag, [
            { transform: "scale(1)" },
            { transform: "scale(1.18) rotate(-4deg)" },
            { transform: "scale(1)" },
          ], { duration: 320, easing: "ease-out" });
        }

        renderCart();
        openCart();
      });
    });

    bag?.setAttribute("role", "button");
    bag?.setAttribute("tabindex", "0");
    bag?.setAttribute("aria-haspopup", "dialog");
    bag?.setAttribute("aria-expanded", "false");
    bag?.addEventListener("click", openCart);
    bag?.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        openCart();
      }
    });

    closeEls.forEach((el) => el.addEventListener("click", closeCart));

    itemsEl?.addEventListener("click", (event) => {
      const control = event.target.closest("[data-cart-inc], [data-cart-dec], [data-cart-remove]");
      if (!control) return;
      const id = control.dataset.cartInc || control.dataset.cartDec || control.dataset.cartRemove;
      const item = cartItems.get(id);
      if (!item) return;

      if (control.dataset.cartInc) item.qty += 1;
      if (control.dataset.cartDec) item.qty -= 1;
      if (control.dataset.cartRemove || item.qty <= 0) cartItems.delete(id);

      renderCart();
    });

    window.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && document.body.classList.contains("cart-drawer-open")) {
        closeCart();
      }
    });

    renderCart();
  }

  function setupFaq() {
    document.querySelectorAll("[data-faq-toggle]").forEach((head) => {
      const toggle = () => {
        const body = head.nextElementSibling;
        const icon = head.querySelector("[data-faq-icon]");
        if (!body) return;

        const open = body.style.maxHeight && body.style.maxHeight !== "0px";
        if (open) {
          body.style.maxHeight = "0px";
          body.style.opacity = "0";
          if (icon) icon.style.transform = "rotate(0deg)";
        } else {
          body.style.maxHeight = `${body.scrollHeight}px`;
          body.style.opacity = "1";
          if (icon) icon.style.transform = "rotate(45deg)";
        }
      };

      head.addEventListener("click", toggle);
      head.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          toggle();
        }
      });
    });
  }

  function setupReveals() {
    const reveals = document.querySelectorAll("[data-reveal]");
    if (!reveals.length) return;

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        el.style.opacity = "1";
        el.style.transform = el.dataset.revealTo || "none";
        io.unobserve(el);
      });
    }, { threshold: 0.18 });

    reveals.forEach((el) => io.observe(el));
  }

  function setupBatchCounter() {
    const counter = document.querySelector("#batch-counter");
    if (!counter) return;

    counter.textContent = "0";
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        io.disconnect();
        const t0 = performance.now();
        const tick = (time) => {
          const progress = Math.min(1, (time - t0) / 1700);
          const eased = 1 - Math.pow(1 - progress, 3);
          counter.textContent = String(Math.round(eased * 246));
          if (progress < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.5 });

    io.observe(counter);
  }

  function setupWordline() {
    const words = [...document.querySelectorAll("[data-wd]")];
    const section = document.querySelector("#wordline");
    if (!section || !words.length) return;

    const onScroll = () => {
      const rect = section.getBoundingClientRect();
      const vh = window.innerHeight;
      const progress = Math.min(1, Math.max(0, (vh * 0.88 - rect.top) / (rect.height + vh * 0.32)));
      const activeCount = Math.floor(progress * words.length * 1.18);
      words.forEach((word, index) => {
        word.style.opacity = index < activeCount ? "1" : "0.14";
        word.style.transform = index < activeCount ? "none" : "translateY(10px)";
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  function setupSocialFeedMotion() {
    const section = document.querySelector(".social-feed");
    const cards = [...(section?.querySelectorAll("[data-social-card]") || [])];
    if (!section || !cards.length) return;

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const dragState = new Map();
    // On mobile the cards live in a native horizontal scroll carousel, so the
    // pointer-drag interaction is disabled there to avoid blocking the swipe.
    const mobileMedia = window.matchMedia("(max-width: 700px)");

    const readNumber = (el, name, fallback) => {
      const value = Number(el.dataset[name]);
      return Number.isFinite(value) ? value : fallback;
    };

    const setCardDrag = (card, x, y) => {
      card.style.setProperty("--drag-x", `${x.toFixed(1)}px`);
      card.style.setProperty("--drag-y", `${y.toFixed(1)}px`);
    };

    const getState = (card) => {
      if (!dragState.has(card)) {
        dragState.set(card, {
          baseX: 0,
          baseY: 0,
          dragX: 0,
          dragY: 0,
          startX: 0,
          startY: 0,
          startDragX: 0,
          startDragY: 0,
          dragging: false,
        });
      }
      return dragState.get(card);
    };

    const clampDrag = (card, x, y) => {
      const state = getState(card);
      const bounds = section.getBoundingClientRect();
      const grid = card.closest(".social-feed__grid") || section;
      const gridBounds = grid.getBoundingClientRect();
      const cardBounds = card.getBoundingClientRect();
      const inset = 12;
      const halfWidth = cardBounds.width / 2;
      const halfHeight = cardBounds.height / 2;
      const baseCenterX = gridBounds.left + gridBounds.width / 2 + state.baseX;
      const baseCenterY = gridBounds.top + gridBounds.height / 2 + state.baseY;
      const minX = bounds.left + halfWidth + inset - baseCenterX;
      const maxX = bounds.right - halfWidth - inset - baseCenterX;
      const minY = bounds.top + halfHeight + inset - baseCenterY;
      const maxY = bounds.bottom - halfHeight - inset - baseCenterY;

      return {
        x: clamp(x, Math.min(minX, maxX), Math.max(minX, maxX)),
        y: clamp(y, Math.min(minY, maxY), Math.max(minY, maxY)),
      };
    };

    const placeCards = () => {
      const spread = clamp(window.innerWidth / 1280, 0.72, 1);
      cards.forEach((card) => {
        const state = getState(card);
        const x = readNumber(card, "x", 0) * spread;
        const y = readNumber(card, "y", 0);
        const rot = readNumber(card, "rot", 0);
        state.baseX = x;
        state.baseY = y;
        card.style.setProperty("--card-x", `${x.toFixed(1)}px`);
        card.style.setProperty("--card-y", `${y.toFixed(1)}px`);
        card.style.setProperty("--card-rot", `${rot.toFixed(2)}deg`);
        const clamped = clampDrag(card, state.dragX, state.dragY);
        state.dragX = clamped.x;
        state.dragY = clamped.y;
        setCardDrag(card, state.dragX, state.dragY);
      });
    };

    cards.forEach((card) => {
      const video = card.querySelector("video");
      const state = getState(card);

      card.addEventListener("pointerdown", (event) => {
        if (event.button !== 0 || mobileMedia.matches) return;
        event.preventDefault();
        state.dragging = true;
        state.startX = event.clientX;
        state.startY = event.clientY;
        state.startDragX = state.dragX;
        state.startDragY = state.dragY;
        card.classList.add("is-dragging");
        card.setPointerCapture?.(event.pointerId);
      });

      card.addEventListener("pointermove", (event) => {
        if (!state.dragging) return;
        const next = clampDrag(
          card,
          state.startDragX + event.clientX - state.startX,
          state.startDragY + event.clientY - state.startY
        );
        state.dragX = next.x;
        state.dragY = next.y;
        setCardDrag(card, state.dragX, state.dragY);
      });

      const endDrag = (event) => {
        if (!state.dragging) return;
        state.dragging = false;
        card.classList.remove("is-dragging");
        card.releasePointerCapture?.(event.pointerId);
      };

      card.addEventListener("pointerup", endDrag);
      card.addEventListener("pointercancel", endDrag);

      if (!video) return;

      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;

      const resetVideo = () => {
        video.pause();
        try {
          video.currentTime = 0;
        } catch (_) {
          // Some browsers block seeking before metadata is ready.
        }
      };

      card.addEventListener("mouseenter", () => {
        if (!mobileMedia.matches) video.play().catch(() => {});
      });
      card.addEventListener("mouseleave", () => {
        if (!mobileMedia.matches) resetVideo();
      });
      card.addEventListener("focusin", () => {
        if (!mobileMedia.matches) video.play().catch(() => {});
      });
      card.addEventListener("focusout", () => {
        if (!mobileMedia.matches) resetVideo();
      });
    });

    // Muted inline video can autoplay on iOS. Mobile plays visible cards by
    // default; desktop keeps the intentional hover/focus interaction above.
    if ("IntersectionObserver" in window) {
      const playObserver = new IntersectionObserver(
        (entries) => {
          if (!mobileMedia.matches) return;
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        },
        { rootMargin: "100px 0px", threshold: [0, 0.25, 0.5, 1] }
      );
      cards.forEach((card) => {
        const video = card.querySelector("video");
        if (video) playObserver.observe(video);
      });

      document.addEventListener("visibilitychange", () => {
        if (!mobileMedia.matches) return;
        if (document.hidden) {
          cards.forEach((card) => card.querySelector("video")?.pause());
          return;
        }
        cards.forEach((card) => {
          const video = card.querySelector("video");
          if (!video) return;
          const rect = video.getBoundingClientRect();
          if (rect.bottom > -100 && rect.top < window.innerHeight + 100) {
            video.play().catch(() => {});
          }
        });
      });

      mobileMedia.addEventListener("change", (event) => {
        cards.forEach((card) => {
          const video = card.querySelector("video");
          if (!video) return;
          if (!event.matches) {
            video.pause();
            try { video.currentTime = 0; } catch (_) {}
            return;
          }
          const rect = video.getBoundingClientRect();
          if (rect.bottom > -100 && rect.top < window.innerHeight + 100) {
            video.play().catch(() => {});
          }
        });
      });
    }

    window.addEventListener("resize", placeCards);
    placeCards();
  }

  function setupCaseCardsTrack() {
    const track = document.querySelector(".case-file__cards-track");
    const windowEl = track?.closest(".case-file__cards");
    const firstCard = track?.querySelector(".case-card");
    if (!track || !firstCard) return;

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const desktopTrack = window.matchMedia("(min-width: 1181px)");
    let step = 0;
    let currentIndex = 0;
    let currentX = 0;
    let timer = 0;
    let animation = null;

    const measure = () => {
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
      const cardWidth = firstCard.getBoundingClientRect().width;
      step = cardWidth + gap;
      track.style.setProperty("--case-step-1", `${(-step).toFixed(1)}px`);
      track.style.setProperty("--case-step-2", `${(-step * 2).toFixed(1)}px`);
      track.style.setProperty("--case-step-3", `${(-step * 3).toFixed(1)}px`);
      windowEl?.style.setProperty("--case-window-width", `${(cardWidth * 3 + gap * 2).toFixed(1)}px`);
    };

    const setTrackX = (x) => {
      currentX = x;
      track.style.transform = `translateX(${x.toFixed(1)}px)`;
    };

    const stop = () => {
      window.clearTimeout(timer);
      animation?.cancel();
      animation = null;
    };

    const slideNext = () => {
      if (reduceMotion.matches || !desktopTrack.matches || step <= 0) {
        setTrackX(0);
        return;
      }

      const nextIndex = currentIndex + 1;
      const target = -step * nextIndex;
      animation = track.animate([
        { transform: `translateX(${currentX.toFixed(1)}px)`, offset: 0 },
        { transform: `translateX(${(target - 18).toFixed(1)}px)`, offset: 0.72 },
        { transform: `translateX(${(target + 5).toFixed(1)}px)`, offset: 0.88 },
        { transform: `translateX(${target.toFixed(1)}px)`, offset: 1 },
      ], {
        duration: 1050,
        easing: "cubic-bezier(0.65, 0, 0.35, 1)",
        fill: "forwards",
      });

      animation.onfinish = () => {
        animation = null;
        currentIndex = nextIndex;
        setTrackX(target);

        if (currentIndex >= 3) {
          currentIndex = 0;
          setTrackX(0);
        }

        timer = window.setTimeout(slideNext, 1700);
      };
    };

    const restart = () => {
      stop();
      measure();
      currentIndex = 0;
      if (desktopTrack.matches) {
        setTrackX(0);
      } else {
        track.style.transform = "";
      }
      if (!reduceMotion.matches && desktopTrack.matches) {
        timer = window.setTimeout(slideNext, 1700);
      }
    };

    window.addEventListener("resize", restart);
    window.addEventListener("load", restart);
    reduceMotion.addEventListener("change", restart);
    desktopTrack.addEventListener("change", restart);
    measure();
    restart();
  }

  function setupMiniGame() {
    const canvas = document.querySelector("#game-canvas");
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    let raf = 0;
    const game = { started: false, over: false, y: 0, vy: 0, obs: [], t: 0, next: 70, score: 0, best: 0 };

    const roundRect = (x, y, w, h, r) => {
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
    };

    const drawFrame = (msg) => {
      const W = canvas.width;
      const H = canvas.height;
      const groundY = H - 56;
      ctx.clearRect(0, 0, W, H);

      ctx.strokeStyle = "rgba(251, 243, 224, 0.9)";
      ctx.lineWidth = 4;
      ctx.setLineDash([16, 12]);
      ctx.beginPath();
      ctx.moveTo(0, groundY + 4);
      ctx.lineTo(W, groundY + 4);
      ctx.stroke();
      ctx.setLineDash([]);

      const cols = ["#FBF3E0", "#AECC3F", "#F2622E"];
      game.obs.forEach((obstacle) => {
        ctx.fillStyle = cols[obstacle.col];
        roundRect(obstacle.x, groundY - obstacle.h, obstacle.w, obstacle.h, 10);
        ctx.fill();
        ctx.fillStyle = "#171310";
        ctx.fillRect(obstacle.x + 8, groundY - obstacle.h + 10, obstacle.w - 16, 4);
        ctx.fillRect(obstacle.x + 8, groundY - 14, obstacle.w - 16, 4);
      });

      const px = 120;
      const ps = 76;
      const py = groundY - ps + game.y;
      ctx.save();
      ctx.translate(px + ps / 2, py + ps / 2);
      ctx.rotate(game.y < 0 ? -0.1 : 0);
      ctx.fillStyle = "#F6BE3B";
      roundRect(-ps / 2, -ps / 2, ps, ps, 24);
      ctx.fill();
      ctx.fillStyle = "rgba(255, 255, 255, 0.5)";
      ctx.beginPath();
      ctx.ellipse(-16, -22, 14, 7, -0.4, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = "#171310";
      ctx.beginPath();
      ctx.arc(-12, -2, 4.5, 0, Math.PI * 2);
      ctx.fill();
      ctx.beginPath();
      ctx.arc(10, -2, 4.5, 0, Math.PI * 2);
      ctx.fill();
      ctx.strokeStyle = "#171310";
      ctx.lineWidth = 3.5;
      ctx.beginPath();
      ctx.arc(-1, 8, 11, 0.15 * Math.PI, 0.85 * Math.PI);
      ctx.stroke();
      ctx.restore();

      ctx.fillStyle = "#FBF3E0";
      ctx.font = "700 24px Archivo, sans-serif";
      ctx.textAlign = "right";
      ctx.fillText(`SCORE ${game.score}${game.best ? `   BEST ${game.best}` : ""}`, W - 28, 46);

      if (msg) {
        ctx.textAlign = "center";
        ctx.fillStyle = "#FBF3E0";
        ctx.font = "44px Smashing, Anton, sans-serif";
        ctx.fillText(msg.title, W / 2, H / 2 - 14);
        ctx.font = "500 22px Archivo, sans-serif";
        ctx.globalAlpha = 0.75;
        ctx.fillText(msg.sub, W / 2, H / 2 + 26);
        ctx.globalAlpha = 1;
      }
    };

    const fit = () => {
      canvas.width = Math.max(300, canvas.clientWidth) * 2;
      canvas.height = 480;
      if (!game.started || game.over) {
        drawFrame({ title: "PRESS SPACE TO JUMP", sub: "or click. we don’t judge." });
      }
    };

    const loop = () => {
      if (game.over) return;

      game.t += 1;
      game.vy += 1.35;
      game.y += game.vy;
      if (game.y > 0) {
        game.y = 0;
        game.vy = 0;
      }

      const W = canvas.width;
      const speed = 11 + Math.min(8, game.score * 0.35);
      if (game.t >= game.next) {
        game.obs.push({ x: W + 60, w: 46, h: 60 + Math.random() * 52, passed: false, col: Math.floor(Math.random() * 3) });
        game.next = game.t + 70 + Math.random() * 65;
      }
      game.obs.forEach((obstacle) => {
        obstacle.x -= speed;
      });
      game.obs = game.obs.filter((obstacle) => obstacle.x + obstacle.w > -20);

      const px = 120;
      const ps = 76;
      const groundY = 480 - 56;
      const pTop = groundY - ps + game.y;
      game.obs.forEach((obstacle) => {
        if (!obstacle.passed && obstacle.x + obstacle.w < px) {
          obstacle.passed = true;
          game.score += 1;
        }

        const margin = 12;
        if (px + ps - margin > obstacle.x && px + margin < obstacle.x + obstacle.w && pTop + ps - margin > groundY - obstacle.h) {
          game.over = true;
          game.best = Math.max(game.best, game.score);
        }
      });

      if (game.over) {
        drawFrame({ title: `OOF. SCORE ${game.score}`, sub: "press space to forgive yourself" });
        return;
      }

      drawFrame(null);
      raf = requestAnimationFrame(loop);
    };

    const jump = () => {
      if (!game.started) {
        game.started = true;
        game.over = false;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(loop);
        game.vy = -24;
        return;
      }

      if (game.over) {
        Object.assign(game, { over: false, obs: [], t: 0, next: 70, score: 0, y: 0, vy: -24 });
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(loop);
        return;
      }

      if (game.y === 0) game.vy = -24;
    };

    const gameVisible = () => {
      const rect = canvas.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    };

    fit();
    window.addEventListener("resize", fit);
    canvas.addEventListener("click", jump);
    window.addEventListener("keydown", (event) => {
      if (event.code === "Space" && gameVisible()) {
        event.preventDefault();
        jump();
      }
    });
  }

  setupStyleHover();
  setupFaq();
  setupReveals();
  setupBatchCounter();
  setupWordline();
  setupCaseCardsTrack();
  setupSocialFeedMotion();
  setupMiniGame();
})();
